module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/order-status.json
// module id = 719
// module chunks = 80586882679298